import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/percepciones-tipos-para-isr';

/**
 * GET Percepciones Tipos ISR
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPercepcionesTiposISR = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Percepcion Tipo ISR
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPercepcionTipoISR = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Percepcion Tipo ISR
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPercepcionTipoISR = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Percepcion Tipo ISR
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPercepcionTipoISR = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Percepcion Tipo ISR
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePercepcionTipoISR = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
